module.exports = __webpack_public_path__ + "img/product_44.58526c0.webp";